module.exports = __webpack_public_path__ + "img/job-icon-4.4ec0a113.png";